import { gql } from '@apollo/client';

export { idempotencyContext } from '@/modules/clinical-records/clinical.gql';

export const HOSP_EPISODE_FIELDS = gql`
  fragment HospEpisodeFields on HospitalizationEpisode {
    id
    folio_number
    pet_id
    customer_id
    attending_vet_id
    originating_clinical_visit_id
    open_account_id
    status
    admission_reason
    location_label
    discharge_type
    discharge_summary
    transfer_destination
    admitted_at
    discharged_at
    deceased_at
    cancelled_at
    cancel_reason
  }
`;

export const HOSPITALIZATION_EPISODES_QUERY = gql`
  ${HOSP_EPISODE_FIELDS}
  query HospitalizationEpisodes($status: String, $branch_id: ID) {
    hospitalizationEpisodes(status: $status, branch_id: $branch_id) {
      ...HospEpisodeFields
    }
  }
`;

export const HOSPITALIZATION_EPISODE_QUERY = gql`
  ${HOSP_EPISODE_FIELDS}
  query HospitalizationEpisode($id: ID!) {
    hospitalizationEpisode(id: $id) {
      ...HospEpisodeFields
    }
  }
`;

export const HOSP_PROGRESS_NOTES_QUERY = gql`
  query HospitalizationProgressNotes($episode_id: ID!) {
    hospitalizationProgressNotes(episode_id: $episode_id) {
      id
      note_kind
      body
      noted_at
      recorded_by
      voided_at
      void_reason
    }
  }
`;

export const HOSP_VITALS_QUERY = gql`
  query HospitalizationVitalSigns($episode_id: ID!) {
    hospitalizationVitalSigns(episode_id: $episode_id) {
      id
      measured_at
      weight_grams
      body_temperature_celsius_tenths
      heart_rate_bpm
      respiratory_rate_bpm
      mucous_membranes
      hydration
      pain_score
      spo2_pct
      systolic_bp
      notes
    }
  }
`;

export const ADMIT_HOSPITALIZATION_MUTATION = gql`
  ${HOSP_EPISODE_FIELDS}
  mutation AdmitHospitalization($input: AdmitHospitalizationInput!) {
    admitHospitalization(input: $input) {
      ...HospEpisodeFields
    }
  }
`;

export const DISCHARGE_HOSPITALIZATION_MUTATION = gql`
  ${HOSP_EPISODE_FIELDS}
  mutation DischargeHospitalization($input: DischargeHospitalizationInput!) {
    dischargeHospitalization(input: $input) {
      ...HospEpisodeFields
    }
  }
`;

export const DECEASED_HOSPITALIZATION_MUTATION = gql`
  ${HOSP_EPISODE_FIELDS}
  mutation RecordHospitalizationDeceased($input: DeceasedHospitalizationInput!) {
    recordHospitalizationDeceased(input: $input) {
      ...HospEpisodeFields
    }
  }
`;

export const TRANSFER_HOSPITALIZATION_MUTATION = gql`
  ${HOSP_EPISODE_FIELDS}
  mutation TransferHospitalization($input: TransferHospitalizationInput!) {
    transferHospitalization(input: $input) {
      ...HospEpisodeFields
    }
  }
`;

export const CANCEL_HOSPITALIZATION_MUTATION = gql`
  ${HOSP_EPISODE_FIELDS}
  mutation CancelHospitalization($input: CancelHospitalizationInput!) {
    cancelHospitalization(input: $input) {
      ...HospEpisodeFields
    }
  }
`;

export const REOPEN_HOSPITALIZATION_MUTATION = gql`
  ${HOSP_EPISODE_FIELDS}
  mutation ReopenHospitalization($episode_id: ID!) {
    reopenHospitalization(episode_id: $episode_id) {
      ...HospEpisodeFields
    }
  }
`;

export const CHANGE_HOSP_LOCATION_MUTATION = gql`
  ${HOSP_EPISODE_FIELDS}
  mutation ChangeHospitalizationLocation($input: ChangeHospitalizationLocationInput!) {
    changeHospitalizationLocation(input: $input) {
      ...HospEpisodeFields
    }
  }
`;

export const ADD_HOSP_NOTE_MUTATION = gql`
  mutation AddHospitalizationNote($input: AddHospitalizationNoteInput!) {
    addHospitalizationNote(input: $input) {
      id
      note_kind
      body
      noted_at
    }
  }
`;

export const RECORD_HOSP_VITAL_MUTATION = gql`
  mutation RecordHospitalizationVital($input: RecordHospitalizationVitalInput!) {
    recordHospitalizationVital(input: $input) {
      id
      measured_at
      weight_grams
    }
  }
`;

export const VOID_HOSP_VITAL_MUTATION = gql`
  mutation VoidHospitalizationVital($input: VoidHospitalizationVitalInput!) {
    voidHospitalizationVital(input: $input) {
      id
      voided_at
    }
  }
`;
